import { Injectable, inject } from '@angular/core';

import { USER_REPOSITORY, UserRepository } from './user-repository';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	private readonly repository = inject<UserRepository>(USER_REPOSITORY);

	public setTokenClaims(userId: string, accessToken: string): Promise<void> {
		return this.repository.setTokenClaims(userId, accessToken);
	}
}
